import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";

export default class HTPInfoAboutFireworkAnimation extends Animation {
  constructor(con: PIXI.Container,scale:number, onComp: () => void) {
    super();
    new Tween.Tween(con.scale)
      .to({ x:scale, y:scale }, 1000)
      .easing(Tween.Easing.Bounce.Out)
      .onComplete(() => onComp())
      .start()
  }
}